import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { ReplacedBy } from "../../types/sale.type";
import { getReplaceFlagChip, getReplacedByLabel } from "./data";

interface ReplaceFlagChipProps {
  replacedBy?: ReplacedBy | null;
}

/** The replacement bill's GPS flag as a small chip; nothing for OK or no flag. */
export function ReplaceFlagChip({ replacedBy }: ReplaceFlagChipProps) {
  const chip = getReplaceFlagChip(replacedBy);
  if (!chip) return null;
  return (
    <Chip
      size="small"
      label={chip.label}
      sx={{
        bgcolor: chip.color + "1A",
        color: chip.color,
        fontWeight: 600,
        height: 22,
      }}
    />
  );
}

interface ReplacedByInfoProps {
  replacedBy?: ReplacedBy | null;
  variant?: "body2" | "caption";
}

/**
 * "แทนด้วย {เลขบิล} · {ร้าน}" plus the GPS chip, for a bill that a PWA replace moved
 * to pending_cancel. Renders nothing when the row carries no replacement (or the
 * backend predates the field).
 */
export default function ReplacedByInfo({
  replacedBy,
  variant = "caption",
}: ReplacedByInfoProps) {
  if (!replacedBy) return null;
  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      columnGap={0.75}
      rowGap={0.25}
    >
      <Typography variant={variant} color="text.secondary">
        {getReplacedByLabel(replacedBy)}
      </Typography>
      <ReplaceFlagChip replacedBy={replacedBy} />
    </Box>
  );
}
